import { APP_BASE_HREF } from '@angular/common';
import {
  APP_INITIALIZER,
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
} from '@angular/core';
import { MAT_RADIO_DEFAULT_OPTIONS } from '@angular/material/radio';
import { CoreModule } from '@fantaz/core';
import { GameHistoryDataAccessModule } from '@fantaz/game-history/data-access';
import { ProfileDataAccessModule } from '@fantaz/profile/data-access';
import { PromoCodeDataAccessModule } from '@fantaz/promo-code/data-access';
import { getAppEnvironmentConfigProvider } from '@fantaz/shared/app-config';
import { TournamentApiService } from '@fantaz/shared/data-access/api';
import { TermsAndConditionsFeaturesShellModule } from '@fantaz/terms-and-conditions/features/shell';
import { TournamentDataAccessV2Module } from '@fantaz/tournaments-v2/data-access';
import { TournamentDataAccessModule } from '@fantaz/tournaments/data-access';
import { UserGameProfileFeaturesShellModule } from '@fantaz/user-game-profile/features/shell';
import { UserVerificationFeaturesShellModule } from '@fantaz/user-verification/features/shell';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing.module';

@NgModule({
  declarations: [AppComponent],
  imports: [
    CoreModule,
    AppRoutingModule,
    TermsAndConditionsFeaturesShellModule,
    PromoCodeDataAccessModule,
    UserGameProfileFeaturesShellModule,
    UserVerificationFeaturesShellModule,
    ProfileDataAccessModule,
    TournamentDataAccessModule,
    TournamentDataAccessV2Module,
    GameHistoryDataAccessModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    {
      provide: APP_BASE_HREF,
      useValue: '/tournaments',
    },
    { provide: Window, useValue: window },
    // Let angular know which value to use when injecting the token at runtime.
    getAppEnvironmentConfigProvider(),
    {
      provide: APP_INITIALIZER,
      useFactory: (tournament: TournamentApiService) => () => {
        return tournament.unsupportedBrowserValidation();
      },
      deps: [TournamentApiService],
      multi: true,
    },
    {
      provide: MAT_RADIO_DEFAULT_OPTIONS,
      useValue: { color: 'accent' },
    },
  ],

  bootstrap: [AppComponent],
})
export class AppModule {}
